/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function Hamburger16({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="16"
      role="img"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 4.75H2V3h12v1.75Zm0 4.125H2v-1.75h12v1.75ZM2 13h12v-1.75H2V13Z"
        fill={CssVars.textColor}
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
